// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';  // Import du routeur

// Utilisation du routeur dans l'application
createApp(App)
  .use(router)  // Injecte le routeur ici
  .mount('#app');
